import React from "react";
import {
  Button,
  Box,
  Text,
  VStack,
  Grid,
  HStack,
  Icon,
  IconButton
} from "@chakra-ui/react";
import { NavLink } from "react-router";
import { FaFolderOpen, FaPencilAlt } from "react-icons/fa";
import { useCatalogs } from "./useCatalogs";
import { LoadingOverlay } from "../../components/LoadingOverlay";
import { useBreadcrumbs } from "../../contexts/BreadcrumbProvider"
import { HelmetComponent } from "../../components/HelmetComponent";
import "./CatalogsPage.scss";

export const CatalogsPage = () => {
  const {
    user,
    catalogs,
    loading,
    storeCatalogInfo
  } = useCatalogs();
  const { addBreadcrumb } = useBreadcrumbs();

  return (
    <>
      <HelmetComponent title={`Catalogs - Home - ${user.firstName} ${user.lastName}`} />
      {loading && <LoadingOverlay />}
      <Box bg="gray.100" p={6} borderRadius="lg" mb={5}>
        <Text fontSize="xl" color="blue.700">What are Catalogs?</Text>
        <Text mt={2} fontSize="sm" color="gray.600">
          Catalogs are structured containers designed to help content creators organize their Courses and Books efficiently. They provide a streamlined way to manage your educational content, making it easy to locate, update, and publish. Catalogs are purely for organizing content on the builder's side and are not visible to learners.
        </Text>
      </Box>
      <Box maxW="container.lg" py={10}>
        <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" }} gap={6}>
          {catalogs.map((catalog, index) => (
            <NavLink to={`/catalog/${catalog.id}`} className="catalog-link" onClick={(e) => addBreadcrumb(catalog.catalogName, `/catalog/${catalog.id}`, false)}>
              <VStack spacing={4} align="stretch">
                <Box
                  key={index}
                  w="100%"
                  borderWidth="1px"
                  borderRadius="lg"
                  bg="white"
                  boxShadow="sm"
                  p="20px"
                  position="relative" // Allows absolute positioning inside
                  onClick={() => storeCatalogInfo(catalog.id)}
                >
                  <NavLink to={`/updatecatalog/${catalog.id}`}>
                    <IconButton
                      variant='ghost'
                      colorScheme='blue'
                      aria-label='Edit'
                      fontSize='10px'
                      position="absolute"
                      top={0}
                      right={0}
                      icon={<FaPencilAlt />}
                      _hover={{
                        background: "none",
                      }}
                    />
                  </NavLink>
                  <HStack>
                    <Icon as={FaFolderOpen} color="blue.500" boxSize={6} />
                    <Text fontSize="md" fontWeight="bold">{catalog.catalogName}</Text>
                  </HStack>
                </Box>
              </VStack>
            </NavLink>
          ))}
        </Grid>
        <NavLink to={`/createcatalog`} onClick={() => addBreadcrumb("Create Catalog", "/createcatalog", false)}>
          <VStack mt={6}>
            <Button colorScheme="blue" size="lg">
              Add Catalog
            </Button>
          </VStack>
        </NavLink>
      </Box>
    </>
  );
};
